<template lang="html">
 <section class="widgets">
  <div class="row">
   <div id='loadingmessage' style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;" v-if="loading">
                            <p style="position: absolute; color: White; top: 40%; left: 40%;">
                                <img src='../../../assets/snakes.gif' /></p>
                        </div>
    <div class="col-md-12 grid-margin">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title mb-0">Released Operations </h4>
          <div v-if="status">
            <div class="justify-content-centermy-1 row">
                 <b-form-fieldset horizontal label="Rows per page" class="col-6">
                  <b-form-select :options="[{text:20,value:20},{text:30,value:30},{text:50,value:50}]" v-model="perPage">
                  </b-form-select>
                </b-form-fieldset>

                <b-form-fieldset horizontal label="Filter" class="col-6">
                  <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                </b-form-fieldset>
              </div>
              <template>
                <b-table striped hover :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" style="font-weight: 200;">
               <template v-slot:cell(rescue)="row">
  <p>{{row.item.release.releasedAt.slice(0,10)}}</p>
</template>
                     <template v-slot:cell(createdAt)="row">
  <p>{{row.item.createdAt.slice(0,10)}}</p>
</template>

 <template v-slot:cell(rescuer)="row">
  <p>{{row.item.rescuer.name}}</p>
</template>

                   <template v-slot:cell(_id)="row">
                  <router-link :to="'/approve/'+row.item._id">
                    <b-button variant="success">View Details</b-button>
                  </router-link>
                    </template>
                    
                   <!-- <template v-slot:cell(photographs)="row">
                       <enlargeable-image v-bind:src="'https://sarpatnapi.leopardtechlabs.in/u/'+row.item.pic" v-bind::src_large="'https://sarpatnapi.leopardtechlabs.in/u/'+row.item.pic">
  <img
    v-bind:src="'https://sarpatnapi.leopardtechlabs.in/u/'+row.item.pic"
    width="50px"
    height="50px"
  />
                      </enlargeable-image>
</template> -->
                   
                </b-table>
              </template>
               <div class="justify-content-center row my-1">
                <b-pagination size="md" :total-rows="this.items.length" :per-page="perPage" v-model="currentPage" />
              </div>
              </div>
              <div v-else>
                <p style="padding-top:10px;padding-bottom:10px">
                  No data found
                </p>
              </div>
        </div>
        
     </div>
    </div>
  </div>
  </section>
 </template>
<script>
import axios from "axios";
import EnlargeableImage from "@diracleo/vue-enlargeable-image";
export default {
  components: {
    EnlargeableImage,
  },
  name: "news",
  data() {
    return {
      items: [],
      status: false,
      fields: [
        {
          key: "rescue",
          label: "Date",
          sortable: true,
        },
        {
          key: "district",
          label: "Situation",
          sortable: true,
        },
        {
          key: "rescuer",
          label: "Rescuer",
          sortable: true,
        },
        {
          key: "_id",
          label: "Action",
        },
      ],
      currentPage: 1,
      perPage: 20,
      filter: null,
      striped: true,
      loading: false,
    };
  },
  mounted: function () {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      axios({
        url: "https://sarpatnapi.leopardtechlabs.in/operation/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: { status: "Released" },
      })
        .then((response) => {
          this.status = response.data.status;
          this.items = response.data.data;
          // var temp = [];
          // for (var i = 0; i < this.items.length; i++) {
          //   var it = this.items[i].reportId;
          //   it._id = this.items[i]._id;
          //   if (this.items[i].reportId.snake)
          //     it.snake = this.items[i].reportId.snake.name;
          //   temp.push(it);
          // }
          // this.items = temp;
          this.loading = false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    approve: function (item) {
      var vm = this;
      vm.item = item.item._id;
      axios({
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        url: "https://sarpatnapi.leopardtechlabs.in/user/activate",
        data: {
          id: vm.item,
        },
      })
        .then((response) => {
          alert("User was successfully Approved");
          this.getList();
        })
        .catch((e) => {});
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/forms/operation/released.vue